import React from 'react';

import ColorItem from './ColorItem.component';

import CN from './ColorMenu.module.scss';

const ColorMenu = React.forwardRef(({ items, activeColor, onClick }, ref) => (
  <div data-bem="ColorPicker__menu" ref={ref} className={CN.component}>
    <div className={CN.colorsContainer}>
      {items.map((item) => (
        <ColorItem key={item.id} color={item.hex} isSelected={item.hex === activeColor} onClick={onClick} />
      ))}
    </div>
  </div>
));

export default ColorMenu;
